export var createEscalationTemplatesApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl, "/escalationTemplates");
    return {
        get: function (dto) { return http.get("".concat(apiUrl, "/").concat(dto.id)); },
        getMetadata: function () { return http.get("".concat(apiUrl, "/metadata")); },
        add: function (dto) { return http.post(apiUrl, dto); },
        update: function (dto) { return http.put("".concat(apiUrl, "/").concat(dto.id), dto); },
        delete: function (dto) { return http.delete("".concat(apiUrl, "/").concat(dto.id)); },
    };
};
export * from './escalation-link-field.builder';
export * from './escalation-template-data.builder';
export * from './escalation-template-metadata.builder';
export * from './escalation-template.builder';
export * from './escalation-text-field.builder';
//# sourceMappingURL=index.js.map